import { object, string, array } from "yup";
import { layoutValidationSchema } from "../layout-form";

export default intl => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });

  return object().shape({
    name: string().required(requiredText),
    description: string().required(requiredText),
    customerId: string().required(requiredText),
    layouts: array().of(layoutValidationSchema(requiredText, intl)),
  });
};
